import React from "react";
import "./TermsAndConditions.css";
import Footer from "./Footer";
import Header from "./Header";

const TermsAndConditions = () => {
  return (
    <>
      <Header />

      <div className="terms-container">
        <h1 className="terms-title">Terms of Service</h1>

        <section className="terms-section">
          <h2>Overview</h2>

          <p>
            This website is operated by Aethearia. Throughout the site, the terms
            “we”, “us” and “our” refer to Aethearia. By visiting our website or
            purchasing from us, you agree to be bound by these Terms of Service,
            along with our Shipping Policy, Refund Policy, and Privacy Policy.
          </p>

          <p>
            These Terms apply to all users of the website, including browsers,
            customers, and anyone accessing or purchasing through our store. If
            you do not agree with these Terms, please do not use this website.
          </p>

          <p>
            We may update these Terms from time to time. Continued use of the
            website after any changes are posted constitutes acceptance of those
            changes.
          </p>
        </section>

        <section className="terms-section">
          <h2>1. Use of Our Website</h2>

          <p>
            By using this website, you confirm that you are legally capable of
            entering into a binding agreement under applicable law.
          </p>

          <p>
            You agree not to use our website or products for any unlawful,
            fraudulent, or unauthorised purpose, and not to interfere with the
            functioning, security, or integrity of the website in any way.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Product Information & Handmade Nature</h2>

          <p>
            All Aethearia products are handcrafted and many are made to order. We
            make every effort to display product colours, finishes, and details
            as accurately as possible; however, slight variations may occur due
            to the handmade nature of our products, natural materials,
            photography, screen settings, and seasonal conditions.
          </p>

          <p>
            Such minor variations in colour, texture, finish, wax appearance,
            herbs, or fragrance intensity are natural and shall not be considered
            defects.
          </p>

          <p>
            We reserve the right to modify, discontinue, or update products,
            descriptions, prices, offers, or availability at any time without
            prior notice.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Pricing, Orders & Acceptance</h2>

          <p>
            All prices displayed on the website are in Indian Rupees (INR)
            unless otherwise stated.
          </p>

          <p>
            We reserve the right to refuse, limit, or cancel any order at our
            sole discretion, including in cases involving:
          </p>

          <ul>
            <li>Incorrect pricing or product information</li>
            <li>Suspected fraudulent transactions</li>
            <li>Bulk, reseller, or duplicate orders</li>
            <li>Stock or fulfilment limitations</li>
            <li>Incomplete or inaccurate billing / shipping information</li>
          </ul>

          <p>
            If an order is cancelled after payment has been made, any applicable
            refund will be processed in accordance with our policies.
          </p>

          <p>
            You are responsible for providing accurate billing, shipping, and
            contact information at the time of purchase.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Shipping & Delivery</h2>

          <p>
            Orders are processed and shipped in accordance with our Shipping
            Policy. Delivery timelines are estimates and may vary due to courier
            delays, public holidays, weather conditions, operational constraints,
            or other circumstances beyond our control.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Returns, Exchanges & Refunds</h2>

          <p>
            All cancellations, returns, exchanges, and refunds are subject to our
            Refund Policy. We encourage you to review it carefully before placing
            an order.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Privacy</h2>

          <p>
            Your submission of personal information through our website is
            governed by our Privacy Policy.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Intellectual Property</h2>

          <p>
            All content on this website—including text, product descriptions,
            photographs, graphics, branding, logos, designs, and other
            materials—is the property of Aethearia and may not be copied,
            reproduced, distributed, modified, republished, or used without prior
            written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Third-Party Links & Services</h2>

          <p>
            Our website may contain links to third-party websites, tools, or
            services for your convenience. We do not control or endorse these
            third parties and are not responsible for their content, practices,
            or policies. Your use of such third-party services is at your own
            discretion and subject to their respective terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Accuracy of Information</h2>

          <p>
            We strive to ensure that the information on our website is accurate
            and up to date. However, occasional errors, omissions, or
            inaccuracies may occur in product descriptions, pricing, offers,
            availability, shipping details, or other website content.
          </p>

          <p>
            We reserve the right to correct such errors, update information, or
            cancel orders where necessary, without prior notice.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. User Feedback & Submissions</h2>

          <p>
            If you choose to share reviews, feedback, suggestions, or other
            submissions with us, you agree that we may use, reproduce, publish,
            or share them for customer service, business, or marketing purposes
            without any obligation of compensation.
          </p>

          <p>
            You agree not to submit content that is unlawful, offensive,
            misleading, defamatory, or in violation of any third-party rights.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Limitation of Liability</h2>

          <p>
            To the fullest extent permitted by law, Aethearia shall not be liable
            for any indirect, incidental, special, or consequential damages
            arising from the use of our website, services, or products.
          </p>

          <p>
            All products and services are provided on an “as available” basis,
            without warranties of any kind except as required under applicable
            law.
          </p>

          <p>
            Nothing in these Terms limits any consumer rights available under
            Indian law.
          </p>
        </section>

        <section className="terms-section">
          <h2>12. Indemnity</h2>

          <p>
            You agree to indemnify and hold harmless Aethearia, its owners,
            affiliates, team members, and service providers from any claims,
            losses, liabilities, damages, or expenses arising out of your misuse
            of the website, breach of these Terms, or violation of applicable
            law.
          </p>
        </section>

        <section className="terms-section">
          <h2>13. Termination</h2>

          <p>
            We reserve the right to suspend or terminate access to our website or
            services if we reasonably believe that a user has violated these
            Terms, engaged in fraudulent activity, or misused the website in any
            manner.
          </p>
        </section>

        <section className="terms-section">
          <h2>14. Governing Law</h2>

          <p>
            These Terms of Service shall be governed by and interpreted in
            accordance with the laws of India. Any disputes arising in connection
            with the use of this website or purchases made through it shall be
            subject to the jurisdiction of the courts of Nagpur, Maharashtra.
          </p>
        </section>

        <section className="terms-section">
          <h2>15. Contact Us</h2>

          <p>
            For any questions regarding these Terms of Service, website use, or
            purchases made through our store, please contact us at:
          </p>

          <div className="contact-box">
            <p>
              <strong>Aether Falcon Endevours</strong>
            </p>

            <p style={{display: "flex"}}>
              <strong>Brand:</strong> Aethearia
            </p>

            <p style={{display: "flex"}}>
              <strong>Address:</strong> H.I.G/B-20, Housing Board Colony,
              Nagpur, Maharashtra – 440022, India
            </p>

            <p style={{display: "flex"}}>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:reachus@aethearia.com"
                className="email-lowercase email-link"
              >
                reachus@aethearia.com
              </a>
            </p>
             {/* <p>
              <b>Email:</b>{" "}
              <a
                href="mailto:reachus@aethearia.com"
                className="email-lowercase"
              >
                reachus@aethearia.com
              </a>
            </p> */}
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default TermsAndConditions;